//TODO: Rename slice to something better to stop conflicting with user actions
import { createSlice } from '@reduxjs/toolkit'

const UserActionsStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    deleteUserStatus: UserActionsStatus.LOADING,
    deleteUserErrorMessage: null,
    deactivateUserStatus: UserActionsStatus.LOADING,
    deactivateUserErrorMessage: null,
    activateUserStatus: UserActionsStatus.LOADING,
    activateUserErrorMessage: null,
}

const userActionsSlice = createSlice({
    name: 'userActions',
    initialState,
    reducers: {
        deleteUserRequest: state => {
            state.deleteUserStatus = UserActionsStatus.LOADING
        },
        deleteUserRequestSuccess: state => {
            state.deleteUserStatus = UserActionsStatus.SUCCESS
        },
        deleteUserRequestError: (state, action) => {
            state.deleteUserStatus = UserActionsStatus.FAILURE
            state.deleteUserErrorMessage = action.payload
        },
        deleteUserReset: state => {
            state.deleteUserStatus = UserActionsStatus.LOADING
            state.deleteUserErrorMessage = null
        },
        deactivateUserRequest: state => {
            state.deactivateUserStatus = UserActionsStatus.LOADING
        },
        deactivateUserRequestSuccess: state => {
            state.deactivateUserStatus = UserActionsStatus.SUCCESS
        },
        deactivateUserRequestError: (state, action) => {
            state.deactivateUserStatus = UserActionsStatus.FAILURE
            state.deactivateUserErrorMessage = action.payload
        },
        deactivateUserReset: state => {
            state.deactivateUserStatus = UserActionsStatus.LOADING
            state.deactivateUserErrorMessage = null
        },
        activateUserRequest: state => {
            state.activateUserStatus = UserActionsStatus.LOADING
        },
        activateUserRequestSuccess: state => {
            state.activateUserStatus = UserActionsStatus.SUCCESS
        },
        activateUserRequestError: (state, action) => {
            state.activateUserStatus = UserActionsStatus.FAILURE
            state.activateUserErrorMessage = action.payload
        },
        activateUserReset: state => {
            state.activateUserStatus = UserActionsStatus.LOADING
            state.activateUserErrorMessage = null
        },
    },
})

const {
    deleteUserRequest,
    deleteUserRequestSuccess,
    deleteUserRequestError,
    deleteUserReset,
    deactivateUserRequest,
    deactivateUserRequestSuccess,
    deactivateUserRequestError,
    deactivateUserReset,
    activateUserRequest,
    activateUserRequestSuccess,
    activateUserRequestError,
    activateUserReset,
} = userActionsSlice.actions

export const userActionsActions = {
    deleteUserRequest,
    deleteUserRequestSuccess,
    deleteUserRequestError,
    deleteUserReset,
    deactivateUserRequest,
    deactivateUserRequestSuccess,
    deactivateUserRequestError,
    deactivateUserReset,
    activateUserRequest,
    activateUserRequestSuccess,
    activateUserRequestError,
    activateUserReset,
}

export const userActionsSelectors = {
    deleteUserIsSubmitting: state =>
        state.userActions.deleteUserStatus === UserActionsStatus.LOADING,
    deleteUserHasError: state =>
        state.userActions.deleteUserStatus === UserActionsStatus.FAILURE,
    deleteUserErrorMessage: state => state.userActions.deleteUserErrorMessage,
    deactivateUserIsSubmitting: state =>
        state.userActions.deactivateUserStatus === UserActionsStatus.LOADING,
    deactivateUserHasError: state =>
        state.userActions.deactivateUserStatus === UserActionsStatus.FAILURE,
    deactivateUserErrorMessage: state =>
        state.userActions.deactivateUserErrorMessage,
    activateUserIsSubmitting: state =>
        state.userActions.activateUserStatus === UserActionsStatus.LOADING,
    activateUserHasError: state =>
        state.userActions.activateUserStatus === UserActionsStatus.FAILURE,
    activateUserErrorMessage: state =>
        state.userActions.activateUserErrorMessage,
}

export const userActionsReducer = userActionsSlice.reducer
